export default __webpack_public_path__ + "static/media/DeleteAccount.cf13122e.svg";